module.exports = __webpack_public_path__ + "img/foward-arrow.920a3887.svg";